import { render, staticRenderFns } from "./BlockDateCardHeader.vue?vue&type=template&id=59b496a4&"
import script from "./BlockDateCardHeader.vue?vue&type=script&lang=js&"
export * from "./BlockDateCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./BlockDateCardHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports